import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedinLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_400_14510)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
			fill: "#0967C2"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M15.9748 10.8052V14.928H13.5845V11.0815C13.5845 10.1157 13.2394 9.45615 12.3739 9.45615C11.7135 9.45615 11.3211 9.9002 11.1479 10.3302C11.0849 10.4838 11.0687 10.6972 11.0687 10.9127V14.9278H8.67827C8.67827 14.9278 8.71035 8.41316 8.67827 7.7388H11.0689V8.75755C11.0641 8.76558 11.0573 8.77342 11.053 8.78109H11.0689V8.75755C11.3866 8.26877 11.9531 7.56999 13.2232 7.56999C14.7958 7.56999 15.9748 8.59748 15.9748 10.8052ZM6.17764 4.27344C5.35997 4.27344 4.82501 4.81018 4.82501 5.51537C4.82501 6.20559 5.34446 6.75784 6.14627 6.75784H6.16178C6.9955 6.75784 7.51388 6.20559 7.51388 5.51537C7.49801 4.81018 6.9955 4.27344 6.17764 4.27344ZM4.96708 14.928H7.35665V7.7388H4.96708V14.928Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_400_14510",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgLinkedinLogo;
